export class HasUnpaidInvoiceException {}